
  export default {
    name: "PopRouteMain",
    props: {
      main: {
        type: String,
        default: 'minsk',
      },
      max: {
        type: Number,
        default: 10,
      },
      settitle: {
        type: Boolean,
        default: false,
      },
      subsettitle: {
        type: Boolean,
        default: true,
      },
      title: {
        type: String,
        default: '',
      },
      list: {
        default: {
          in_city: [],
          out_city: []
        }
      }
    },
    computed : {
      in_city () {
        let mas = []
        let max = this.max
        this.list.in_city.map((v) => {
          if (mas.length  < max) {
            mas.push(v)
          }
        })
        return mas
      },
      out_city () {
        let mas = []
        let max = this.max
        this.list.out_city.map((v) => {
          if (mas.length < max) {
            mas.push(v)
          }
        })
        return mas
      }
    },
    methods: {
     pushPopList(from, to) {
        this.$router.push(this.localeLocation({path: `/bus-search/${from}/${to}`}));
      }
    }
  }
